import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    claimButton: {
      intercomMessage: 'Hello, I would like to report an accident\n',
    },
    content: {
      exclude: {
        items: [
          'Reimbursement for medications purchased without a prescription;',
          'Dental and medical fees not resulting from an urgent situation;',
          'Expenses paid with a card other than the one issued by Shine.',
        ],
        title: 'This guarantee does not include',
      },
      include: {
        items: [
          'Coverage for care received following an illness or accident occurring outside your country of residence;',
          'Reimbursement of medical expenses incurred with our prior approval, which have not been covered by any insurance organizations you are affiliated with;',
        ],
        title: 'This guarantee includes',
      },
    },
    similarOffersTitle: 'Related insurance offers',
    title: 'Health expenses abroad',
  },
  fr: {
    claimButton: {
      intercomMessage: 'Bonjour, je souhaiterais déclarer un accident\n',
    },
    content: {
      exclude: {
        items: [
          'Le remboursement des médicaments achetés sans préscription ;',
          'Les frais dentaires et les honoraires médicaux ne résultant pas d’une situation urgente ;',
          'Les frais réglés une carte autre que celle émise par Shine.',
        ],
        title: 'Cette garantie n’inclut pas',
      },
      include: {
        items: [
          "La prise en charge des soins reçus à la suite d'une maladie ou d'un accident survenu hors de votre pays de domicile ;",
          "Le remboursement des frais médicaux engagés avec notre accord préalable, qui n'auront pas été pris en charge par les éventuels organismes d’assurance auxquels vous êtes affiliés ;",
        ],
        title: 'Cette garantie inclut',
      },
    },
    similarOffersTitle: 'Autres assurances liées',
    title: 'Frais de santé à l’étranger',
  },
} as const);

export default locales;
